<template>
  <div class="modal fade create-new-goal-modal" id="CreateGoalsModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar meta</h1>
                  <button type="button" class="btn-close create-new-goal-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateUser" @submit.prevent="createGoalMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para criar uma meta</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="goal_month_created" class="form-label fw-medium"
                      >Mês</label
                    >
                    <input
                      type="number"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="goal_month_created"
                      autocomplete="off"
                      min="1" 
                      max="12"
                      maxlength="2"
                      placeholder="01"
                      pattern="[0-9]{2}"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="goal_year_created" class="form-label fw-medium"
                      >Ano</label
                    >
                    <input
                      type="number"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="goal_year_created"
                      autocomplete="off"
                      min="2024" 
                      max="2070" 
                      placeholder="2025"
                      maxlength="4"
                      pattern="[0-9]{4}"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="goal_price_created" class="form-label fw-medium"
                      >Meta</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="goal_price_created"
                      autocomplete="off"
                      v-model="faturamento"
                      @input="maskMoney"
                      placeholder="Ex: 1.150,00"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiCreateGoal" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageCreateGoal">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger create-new-goal-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonCreateGoal" class="btn btn-success">Criar meta</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "CreateGoalsModal",
  data () {
    return {
      faturamento: null
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.faturamento = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.faturamento = value;
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    createGoalMethod(){
      const alertResponse = this.alertResponse;

      const goal_month_created = document.getElementById("goal_month_created").value;
      const goal_year_created = document.getElementById("goal_year_created").value;
      const goal_price_created = document.getElementById("goal_price_created").value;

      let error = false;

      if(
        goal_month_created == "" ||
        goal_year_created == "" ||
        goal_price_created == ""
      ){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      if(goal_month_created == ""){
        this.$refs.goal_month_created.style.borderColor = "red";
        error = true;
      }

      if(goal_price_created == ""){
        this.$refs.goal_price_created.style.borderColor = "red";
        error = true;
      }

      if(error){
        return;
      }

      const objGoalCreate = {
        "month": goal_month_created,
        "year": goal_year_created,
        "goal": goal_price_created,
      }

      const buttonCreateGoal = this.$refs.buttonCreateGoal;
      buttonCreateGoal.disabled = true;
      buttonCreateGoal.innerHTML = "Criando meta...";
      
      api.axios.post("/api/create/goal", objGoalCreate).catch(function(error){
        if(error.response.data != undefined){
          buttonCreateGoal.innerHTML = "Criar meta";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonCreateGoal.innerHTML = "Meta criada com sucesso !";
          window.location.reload();
        } else {
          buttonCreateGoal.disabled = false;
          buttonCreateGoal.innerHTML = "Criar meta";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageCreateGoal").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageCreateGoal").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiCreateGoal");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>